module.exports = __webpack_public_path__ + "static/img/20.6a8470a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/customization/20.png
// module id = zrVM
// module chunks = 1